const ESQUEMAS_PERMITIDOS = ['http:', 'https:'];

/**
 * Valida URL vinda de resposta de servidor antes de entrar em sink de navegação
 * (`anchor.href` + `.click()`, `window.open`).
 *
 * React não neutraliza `javascript:` em `href`, e um clique programático executa no
 * origin da página. Só `http(s)` e caminho relativo passam; qualquer outra coisa —
 * inclusive `undefined` virando a string `"undefined"` — é rejeitada.
 */
export function ehUrlNavegavelSegura(valor: unknown): valor is string {
  if (typeof valor !== 'string') return false;
  const url = valor.trim();
  if (url.length === 0) return false;
  if (url.startsWith('/') && !url.startsWith('//')) return true;
  try {
    return ESQUEMAS_PERMITIDOS.includes(new URL(url).protocol);
  } catch {
    return false;
  }
}

/** Versão que lança — para boundary de service, onde o contrato do back é a origem. */
export function assertUrlNavegavelSegura(valor: unknown, contexto: string): string {
  if (!ehUrlNavegavelSegura(valor)) {
    throw new Error(`${contexto}: o servidor não devolveu uma URL navegável válida`);
  }
  return valor.trim();
}
